import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazyPdfViewer = clientOnlyLazy(() =>
  import('./PdfViewer').then((module) => ({ default: module.PdfViewer })),
);
